import { useQuery, useQueryClient } from "react-query";

export function useGlobalState(key, initialState) {
    const queryClient = useQueryClient();

    // 1. Read from the cache using a unique key
    const { data } = useQuery({
        queryKey: ['globalState', key],
        queryFn: () => initialState,     // Fallback function
        initialData: initialState,       // Set initial client state
        staleTime: Infinity,             // Prevent React Query from refetching
    });

    // 2. Write to the cache to update all subscribers
    const setState = (newState) => {
        queryClient.setQueryData(['globalState', key], (oldData) => {
            const fallback = oldData ?? initialState;
            return typeof newState === 'function'
                ? (newState)(fallback)
                : newState;
        });
    };

    return [data ?? initialState, setState];
}
